export const MAX_ADDRESSES = 2;
export const ADDR_START_ID = 5;
